import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { trendMonthsFrom } from '@/features/sales-reports/api'
import { SalesTrendReportScreen } from '@/features/sales-reports/trend-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/sales/reports/trend')({
  validateSearch: (search: Record<string, unknown>) => ({ months: trendMonthsFrom(search.months) }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'sales_order.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: SalesTrendRoute,
})

function SalesTrendRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <SalesTrendReportScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/sales/reports/trend', search: next })}
    />
  )
}
